export const donateRouts = {
  root: '/donate',
};
